import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson24: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between max-md:gap-5">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson23"}>
          <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Bulking</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson25"}>
          <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Bulking</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When it comes to achieving your bulking goals, finding the right
            combination can be quite complex. It's not as simple as going to the
            gym and expecting immediate results.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The saying that "abs are made in the kitchen and not in the gym"
            holds true, and the same concept applies to building any muscle
            gains. To build muscle mass, you need to provide your body with
            proper fuel and nutrition.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Different goals, such as weight loss, strength training,
            hypertrophy, and weight gain, require different distribution of the
            three macronutrients. In the following sections, we will explore the
            role of each macronutrient in your body and discuss how you can
            incorporate them into your bulking meal plan.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            There are a few reasons why people bulk. Some people bulk to build
            muscle mass for strength sports like powerlifting or bodybuilding.
            Others bulk to improve their physique. And still others bulk simply
            because they enjoy eating more food.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            No matter what your reason for bulking, it is important to do it
            properly. If you don't, you could end up gaining more fat than
            muscle.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Macronutrients are the nutrients that your body needs in large
            amounts. There are three main macronutrients: carbohydrates,
            protein, and fat.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Carbohydrates</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Carbohydrates are your body's main source of energy. They are
                found in foods like bread, pasta, rice, fruits, vegetables, and
                dairy products. Carbohydrates are broken down into glucose,
                which is the body's main source of energy. Glucose is used by
                the brain, muscles, and other organs.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Carbohydrates also provide fiber, which is important for
                digestive health. Fiber helps to keep you feeling full and can
                help to regulate blood sugar levels.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Protein</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Protein is essential for building and repairing tissues. It is
                also important for muscle growth and strength. Protein is found
                in foods like meat, poultry, fish, eggs, dairy products, and
                beans.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Protein is made up of amino acids. There are nine essential
                amino acids that the body cannot produce on its own. These amino
                acids must be obtained from food.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Fat</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Fat is essential for storing energy, protecting organs, and
                absorbing vitamins. Fat is found in foods like meat, poultry,
                fish, dairy products, nuts, seeds, and oils.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There are two main types of fat: saturated fat and unsaturated
                fat. Saturated fat is found in animal products and some plant
                oils. Unsaturated fat is found in plant oils, nuts, and seeds.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Saturated fat can raise cholesterol levels, which increases the
                risk of heart disease. Unsaturated fat can lower cholesterol
                levels and reduce the risk of heart disease.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                <span>Good sources of macronutrients for bulking</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <b>{`Carbohydrates: `}</b>
                <span className="font-dm-sans">
                  Whole grains, fruits, vegetables, dairy products
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Protein:</b>
                <span> Meat, poultry, fish, eggs, dairy products, beans</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Fat:</b>
                <span> Nuts, seeds, oils</span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How to use macronutrients for bulking</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                To bulk up, you need to consume more calories than you burn.
                This is called a calorie surplus. A calorie surplus will help
                you gain weight, including muscle mass. However, it is important
                to note that a calorie surplus can also lead to fat gain. To
                minimize fat gain, you should combine your calorie surplus with
                strength training and cardio training.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A good rule of thumb is to consume 40-60% of your calories from
                carbohydrates, 25-35% of your calories from protein, and 15-25%
                of your calories from fat.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Tips for bulking up</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Here are a few tips to help you bulk up effectively:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Eat a calorie surplus of 500-1000 calories per day.</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Focus on consuming enough protein, carbohydrates, and fat.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Lift weights regularly.</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Do cardio training.</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Get enough sleep.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Be patient. It takes time to build muscle.</span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Calculating Your Basal Metabolic Rate</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  The first step to bulking up is to calculate your basal
                  metabolic rate (BMR). Your BMR is the number of calories your
                  body burns at rest. You can use the Harris-Benedict formula to
                  calculate your BMR
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  here are the two most common formulas for calculating your
                  basal metabolic rate (BMR):
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Harris-Benedict Formula</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  For men: BMR = 66 + (13.7 x weight in kilograms) + (5 x height
                  in centimeters) - (6.8 x age in years)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  For women: BMR = 655 + (9.6 x weight in kilograms) + (1.8 x
                  height in centimeters) - (4.7 x age in years)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Mifflin-St Jeor Formula</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  BMR = 10 x weight in kilograms + 6.25 x height in centimeters
                  - 5 x age in years + 5 (for men) or -161 (for women)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  These formulas are just estimates, and your actual BMR may
                  vary depending on your individual factors such as body
                  composition, muscle mass, and activity level. To get a more
                  accurate estimate of your BMR, you can use a BMR calculator or
                  have your BMR measured by a healthcare professional.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Once you have calculated your BMR, you can determine how many
                  calories you need to eat in a day to bulk up. A good starting
                  point is to add 500-1000 calories to your BMR. This will help
                  you gain weight at a healthy rate.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Creating a Meal Plan</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When creating a meal plan for bulking up, it is important to
                focus on consuming enough protein, carbohydrates, and fat. A
                good rule of thumb is to consume 40-60% of your calories from
                carbohydrates, 25-35% of your calories from protein, and 15-25%
                of your calories from fat.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Carbohydrates are the body's main source of energy. They are
                also important for muscle growth and repair. Good sources of
                carbohydrates include whole grains, fruits, vegetables, and
                dairy products.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Protein is essential for building and repairing muscle tissue.
                It is also important for muscle growth and strength. Good
                sources of protein include meat, poultry, fish, eggs, dairy
                products, and beans.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Fat is essential for storing energy, protecting organs, and
                absorbing vitamins. Good sources of fat include nuts, seeds, and
                oils.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Supplements</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Supplements can be a helpful way to ensure that you are
                  getting enough protein and other nutrients. Two popular
                  supplements for bulking up are whey protein and creatine. Whey
                  protein is a complete protein that provides all nine essential
                  amino acids. Creatine is a substance that helps to increase
                  muscle mass and strength.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here are the same sample daily bulking diets with calories
                  count and grams:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Diet 1</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Breakfast:</b>
                <span>
                  {" "}
                  Oatmeal with peanut butter and banana (450 calories, 50 grams
                  of carbohydrates, 10 grams of protein, 15 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Snack:</b>
                <span> Protein shake (200 calories, 25 grams of protein)</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Lunch:</b>
                <span>
                  {" "}
                  Chicken breast with brown rice and vegetables (500 calories,
                  50 grams of carbohydrates, 40 grams of protein, 10 grams of
                  fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Snack: `}</b>
                <span>
                  Trail mix (200 calories, 15 grams of carbohydrates, 10 grams
                  of protein, 10 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Dinner:</b>
                <span>
                  {" "}
                  Salmon with sweet potato and roasted broccoli (600 calories,
                  50 grams of carbohydrates, 40 grams of protein, 20 grams of
                  fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Diet 2</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Breakfast:</b>
                <span>
                  {" "}
                  Eggs with whole-wheat toast and avocado (400 calories, 50
                  grams of carbohydrates, 20 grams of protein, 20 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Snack:</b>
                <span>
                  {" "}
                  Greek yogurt with berries (200 calories, 30 grams of
                  carbohydrates, 15 grams of protein, 0 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Lunch:</b>
                <span>
                  {" "}
                  Turkey burger on a whole-wheat bun with lettuce, tomato, and
                  onion (500 calories, 40 grams of carbohydrates, 30 grams of
                  protein, 20 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Snack:</b>
                <span>
                  {" "}
                  Nuts (200 calories, 15 grams of carbohydrates, 10 grams of
                  protein, 10 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Dinner:</b>
                <span>
                  {" "}
                  Steak with mashed potatoes and green beans (600 calories, 50
                  grams of carbohydrates, 40 grams of protein, 20 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Diet 3</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Breakfast:</b>
                <span>
                  {" "}
                  Pancakes with protein powder and fruit (400 calories, 50 grams
                  of carbohydrates, 20 grams of protein, 20 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Snack:</b>
                <span> Protein bar (200 calories, 25 grams of protein)</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Lunch:</b>
                <span>
                  {" "}
                  Lentil soup with whole-wheat bread (500 calories, 40 grams of
                  carbohydrates, 20 grams of protein, 20 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Snack:</b>
                <span>
                  {" "}
                  Hard-boiled eggs (200 calories, 15 grams of carbohydrates, 10
                  grams of protein, 10 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Dinner:</b>
                <span>
                  {" "}
                  Chicken stir-fry with brown rice (600 calories, 50 grams of
                  carbohydrates, 40 grams of protein, 20 grams of fat)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  These are just a few examples, and you can adjust the meals to
                  fit your own preferences and dietary needs. It is important to
                  make sure that you are getting enough protein, carbohydrates,
                  and fat each day to support your muscle growth and repair.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                <span>Tools to help you bulk</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <b>Eat this much ‘phone app’</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  It is a meal planning app that helps you create personalized
                  meal plans based on your dietary needs and preferences. The
                  app has a large database of recipes, and you can customize
                  your meal plans to fit your budget and calorie goals. Eat This
                  Much also offers a premium subscription that provides
                  additional features, such as the ability to track your
                  progress and access exclusive recipes.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Here are some of the features of Eat This Much:</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Personalized meal plans:</b>
                <span>
                  {" "}
                  Eat This Much creates meal plans based on your dietary needs
                  and preferences.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Large database of recipes:</b>
                <span>
                  {" "}
                  The app has a large database of recipes, so you can find
                  something you like to eat.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Customization: `}</b>
                <span>
                  You can customize your meal plans to fit your budget and
                  calorie goals.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Premium subscription:</b>
                <span>
                  {" "}
                  The premium subscription offers additional features, such as
                  the ability to track your progress and access exclusive
                  recipes.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Overall, Eat This Much is a great meal planning app that can
                  help you create healthy and delicious meals. The app is easy
                  to use and has a lot of features, making it a good option for
                  people who are looking for a way to improve their diet.
                </span>
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson25"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
            <b className="self-stretch relative">Next Chapter</b>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Lesson24;
